var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.currentComponent,{tag:"component"}),(_vm.showDebug)?_c('div',{staticClass:"debug-info"},[_c('p',[_vm._v("设备类型: "+_vm._s(_vm.isMobile ? '移动端' : '桌面端'))]),_c('p',[_vm._v("屏幕宽度: "+_vm._s(_vm.screenWidth)+"px")]),_c('p',[_vm._v("User Agent: "+_vm._s(_vm.isMobileUA ? '移动设备' : '桌面设备'))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }